var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.384804,
    height: 72,
    viewBox: "0 0 72.384804 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10358:21807",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 38,
    width: 28,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 57.0011,39.6918 c 0,-0.8497 -0.6888,-1.5385 -1.5384,-1.5385 H 33.155 c -0.8497,0 -1.5385,0.6888 -1.5385,1.5385 0,0.8497 0.6888,1.5384 1.5385,1.5384 h 22.3077 c 0.8496,0 1.5384,-0.6887 1.5384,-1.5384 z M 57,55.5 C 57,54.6716 56.3284,54 55.5,54 h -9 c -0.8284,0 -1.5,0.6716 -1.5,1.5 0,0.8284 0.6716,1.5 1.5,1.5 h 9 C 56.3284,57 57,56.3284 57,55.5 Z M 57.5,46 c 0.8284,0 1.5,0.6716 1.5,1.5 0,0.8284 -0.6716,1.5 -1.5,1.5 h -19 C 37.6716,49 37,48.3284 37,47.5 37,46.6716 37.6716,46 38.5,46 Z",
    fill: "#ebf4ef",
    id: "path8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g847"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18.5002,47 c 0,12.8381 11.5786,23.5 26.1923,23.5 3.9672,0 7.7221,-0.791 11.0839,-2.2025 1.0495,-0.4407 2.2426,-0.6075 3.4276,-0.362 l 8.9059,1.8449 C 66.669,67.15 65.107,62.8373 67.3692,58.7708 69.1841,55.5084 70.8848,51.1894 70.8848,47 70.8848,34.162 59.3061,23.5 44.6925,23.5 30.0788,23.5 18.5002,34.162 18.5002,47 Z",
    fill: "#e62645",
    stroke: "#e62645",
    strokeWidth: 3,
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.5003,31.5001 c 0,13.8071 -13.5141,24.5 -28.8082,24.5 -4.0852,0 -7.8104,-0.9002 -11.2638,-2.3588 -0.9274,-0.3917 -1.6605,-1.1571 -1.9328,-2.1263 -4.685,-16.6789 22.4618,-35.1842 39.7754,-26.7824 0.9339,0.4532 1.5955,1.3243 1.797,2.3426 0.2841,1.4362 0.4324,2.915 0.4324,4.4249 z",
    fill: "#a7163e",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 57.0011,39.6918 c 0,-0.8497 -0.6888,-1.5385 -1.5384,-1.5385 H 33.155 c -0.8497,0 -1.5385,0.6888 -1.5385,1.5385 0,0.8497 0.6888,1.5384 1.5385,1.5384 h 22.3077 c 0.8496,0 1.5384,-0.6887 1.5384,-1.5384 z M 57,55.5 C 57,54.6716 56.3284,54 55.5,54 h -9 c -0.8284,0 -1.5,0.6716 -1.5,1.5 0,0.8284 0.6716,1.5 1.5,1.5 h 9 C 56.3284,57 57,56.3284 57,55.5 Z M 57.5,46 c 0.8284,0 1.5,0.6716 1.5,1.5 0,0.8284 -0.6716,1.5 -1.5,1.5 h -19 C 37.6716,49 37,48.3284 37,47.5 37,46.6716 37.6716,46 38.5,46 Z",
    fill: "#ebf4ef",
    id: "path6"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10358:21807)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 59.5,31.5 c 0,13.8071 -13.5141,24.4998 -28.8082,24.4998 -4.0852,0 -7.8104,-0.9002 -11.2638,-2.3588 -0.9273,-0.3917 -1.6606,-1.1574 -1.9335,-2.1264 -4.6571,-16.5407 22.3724,-33.674 39.5961,-26.7465 1.0434,0.4196 1.7939,1.3467 2.0051,2.4514 C 59.3615,28.6103 59.5,30.0406 59.5,31.5 Z",
    fill: "#a7163e",
    fillOpacity: 0.4,
    id: "path11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 53.8846,25 c 0,12.8381 -11.5787,23.5 -26.1923,23.5 -3.9673,0 -7.7222,-0.791 -11.084,-2.2025 -1.0495,-0.4407 -2.2425,-0.6075 -3.4276,-0.362 L 4.2749,47.7804 C 5.71577,45.15 7.27777,40.8373 5.01556,36.7708 3.2007,33.5084 1.5,29.1894 1.5,25 1.5,12.162 13.0787,1.5 27.6923,1.5 42.3059,1.5 53.8846,12.162 53.8846,25 Z",
    fill: "#ffeadb",
    stroke: "#ffeadb",
    strokeWidth: 3,
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 15.3841,17.6548 c 0,-0.8284 0.6716,-1.5 1.5,-1.5 h 22.3846 c 0.8285,0 1.5,0.6716 1.5,1.5 0,0.8284 -0.6715,1.5 -1.5,1.5 H 16.8841 c -0.8284,0 -1.5,-0.6716 -1.5,-1.5 z m 0,15.3846 c 0,-0.8284 0.6716,-1.5 1.5,-1.5 h 17.7692 c 0.8285,0 1.5,0.6716 1.5,1.5 0,0.8285 -0.6715,1.5 -1.5,1.5 H 16.8841 c -0.8284,0 -1.5,-0.6715 -1.5,-1.5 z m -0.8079,-9.1926 c -0.8285,0 -1.5,0.6716 -1.5,1.5 0,0.8285 0.6715,1.5 1.5,1.5 h 13.923 c 0.8285,0 1.5,-0.6715 1.5,-1.5 0,-0.8284 -0.6715,-1.5 -1.5,-1.5 z",
    fill: "#ef7c00",
    id: "path17"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgComment);
export default __webpack_public_path__ + "static/media/imgComment.fe13333ddc3d2cb3edcae6d5f1bb4023.svg";
export { ForwardRef as ReactComponent };